<template>
  <div class="event-wizard__footer" :class="{'fluid': fluid}">
    <CRow>
      <CCol>
        <div class="d-flex justify-content-end">
          <slot>
            <div>
              <CButton color="primary" @click="$emit('save')" block ref="save-button"
                       :disabled="saveDisabled"
                       v-translate translate-context="event_wizard">
                Save
              </CButton>
            </div>
          </slot>
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "TabFooter",
  emits: ['save', 'reset'],
  props: {
    fluid: {
      type: Boolean,
      default: false
    },
    saveDisabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>